import React from "react";
import Dropdown from "react-multilevel-dropdown";
import { GetAllRolesDTO } from "../../api-client-nswag/taxportal-client";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import "./NestedDropDownV2.css";

interface NestedDropDownTypesV2 {
  rolesData: GetAllRolesDTO[];
  provideAccess: boolean;
  handleRoleClick: (roleId: string, name: string) => void;
  handleClickApp: (name: string) => void;
  handleExternalUser: (option: string) => void;
  handleThirdPartyUser: (option: string) => void;
  appName: string;
  handleIURClick: () => void;
  handleMemberFirmUser: (option: string) => void;
  handleTESSForIsClick: () => void;
  handleTESSIsheet: () => void;
  handleIURConsentCheck: () => void;
}

const NestedDropDownV2: React.FC<NestedDropDownTypesV2> = ({
  rolesData,
  provideAccess,
  handleRoleClick,
  handleClickApp,
  handleExternalUser,
  handleThirdPartyUser,
  appName,
  handleIURClick,
  handleMemberFirmUser,
  handleTESSForIsClick,
  handleTESSIsheet,
  handleIURConsentCheck,
}) => {
  const applicationRoles: GetAllRolesDTO[] = [
    { name: "L1 Support", roleId: "l1support", displayName: "L1 Support" },
    { name: "TESS", roleId: "tess", displayName: "TESS" },
    { name: "TESS_application", roleId: "tess_application", displayName: "TESS Application" }
  ];
  const clientUserOptions = ["Client User Requests", "Check Status"];
  const thirdPartyOptions = ["Third Party User Isheet", "Check Status"];
  const memberFirmOptions = ["Member Firm User Isheet", "Check Status"];
  const internalUserOptions = ["Internal User Isheet", "Apply 7216 check"];
  const tessPattern = /tess/i;
  const supportPattern = /\s*support$/i;
  const supportRoles: GetAllRolesDTO[] = rolesData
    .filter((role) => supportPattern.test(role.name ?? ""))
    .map((role) => ({
      ...role,
      displayName:tessPattern.test(role.displayName ?? "") ? role.displayName : `${role.displayName} from CEM`,
    }));

  // Only keep Internal User Isheet, TESS, and TESS_application in internalRoles
  const internalRoles: GetAllRolesDTO[] = [
    { name: "Internal User Isheet", roleId: "internal_User_isheet", displayName: "Internal User" },
    // { name: "TESS", roleId: "tess", displayName: "TESS" },
    // { name: "TESS_application", roleId: "tess_application", displayName: "TESS Application" }
  ];
  supportRoles.sort((a, b) => a.name?.localeCompare(b.name ?? "") ?? 0);
  const isRoleEnabledForSelection = (roleName: string): boolean => {
    if (!provideAccess) return true;
    return ["tess", "l1 support"].includes(roleName.toLowerCase());
  };

  const onClickApplicationHandler = (name: string) => {
    handleClickApp(name);
  }
  const onClickHandler = (roleId: string, name: string) => {
    if (roleId === "internal_User_isheet") {
      if(name==="Internal User Isheet"){
      handleIURClick();
      }
      else{ 
        //Need to implement when more options are added in future
        handleIURConsentCheck();
      }
    } else {
      handleRoleClick(roleId, name);
    }
  };

 const renderDropdownItems = (
    roles: GetAllRolesDTO[],
    isDisabledCheck: (name: string) => boolean,
    onClick: (roleId: string, name: string) => void
  ) => {
    return roles.map((role) => (
      <Dropdown.Item
        key={role.roleId}
        isDisabled={!isDisabledCheck(role.name ?? "")}
   onClick={() => {          if (role.roleId === "internal_User_isheet") return; 
          onClick(role.roleId ?? "", role.name ?? "");
        }}
      >
        {role.roleId === "internal_User_isheet" && (
          <Dropdown.Submenu className="dropdown-submenu">
            {renderOptionsSubmenu(internalUserOptions, (option) => onClick(role.roleId ?? "", option))}
          </Dropdown.Submenu>
        )}
        <div style={{ color: isDisabledCheck(role.name ?? "") ? "black" : "lightgray" }}>{role.displayName}</div>
      </Dropdown.Item>
    ));
  };

  const renderOptionsSubmenu = (options: string[], onClick: (option: string) => void) => {
    return options.map((option) => (
      <Dropdown.Item key={option} onClick={() => onClick(option)}>
        {option}
      </Dropdown.Item>
    ));
  };

  return (
    <div>
      <Dropdown
        title={
          <div className="select-box-header">
            <span>Assign Users</span>
            <ArrowDropDownIcon />
          </div>
        }
      >
        {appName === "IS" && (
          <>
          <Dropdown.Item onClick={handleTESSForIsClick}>
            TESS Internal User Isheet
          </Dropdown.Item>
          <Dropdown.Item onClick={handleTESSIsheet}>TESS Isheet</Dropdown.Item>
          </>
        )}
        {appName !== "IS" && (
        <>
        <Dropdown.Item>
          <div style={{ color: provideAccess ? "lightgray" : "black" }}>
            Internal Roles
          </div>
          {!provideAccess && (
            <Dropdown.Submenu className="dropdown-submenu">
              {renderDropdownItems(internalRoles, isRoleEnabledForSelection, onClickHandler)}
            </Dropdown.Submenu>
          )}
        </Dropdown.Item>
        <Dropdown.Item>
          <div style={{ color: provideAccess ? "lightgray" : "black" }}>External Roles</div>
          {!provideAccess && (
            <Dropdown.Submenu className="dropdown-submenu">
              <Dropdown.Item>
                <div style={{ color: provideAccess ? "lightgray" : "black" }}>Client User</div>
                <Dropdown.Submenu className="dropdown-submenu">
                  {renderOptionsSubmenu(clientUserOptions, handleExternalUser)}
                </Dropdown.Submenu>
              </Dropdown.Item>
              <Dropdown.Item>
                <div style={{ color: provideAccess ? "lightgray" : "black" }}>Third Party User</div>
                <Dropdown.Submenu className="dropdown-submenu">
                  {renderOptionsSubmenu(thirdPartyOptions, handleThirdPartyUser)}
                </Dropdown.Submenu>
              </Dropdown.Item>
                <Dropdown.Item>
                  <div style={{ color: provideAccess ? "lightgray" : "black" }}>Member Firm User</div>
                  <Dropdown.Submenu className="dropdown-submenu">
                    {renderOptionsSubmenu(memberFirmOptions, handleMemberFirmUser)}
                  </Dropdown.Submenu>
                </Dropdown.Item>
            </Dropdown.Submenu>
          )}
        </Dropdown.Item>
        {/* <Dropdown.Item>
        <div style={{ color: provideAccess ? "lightgray" : "black" }}>Support Roles</div>
          {!provideAccess && (
          <Dropdown.Submenu className="dropdown-submenu">
            {renderDropdownItems(supportRoles, isRoleEnabledForSelection, onClickHandler)}
          </Dropdown.Submenu>
          )}
        </Dropdown.Item>
        <Dropdown.Item>
          <div>Application</div>
          <Dropdown.Submenu className="dropdown-submenu">
            {renderDropdownItems(applicationRoles, isRoleEnabledForSelection, onClickApplicationHandler)}
          </Dropdown.Submenu>
        </Dropdown.Item> */}
        </>
        )}
      </Dropdown>
    </div>
  );
};

export default NestedDropDownV2;
